import { inject } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import * as React from 'react';

import { ILocalization } from 'bernie-l10n';
import { updateSearch } from 'bernie-core';

import { LineOfBusinessDomain, OneKeyBanner, PageLocation } from '@shared-ui/retail-loyalty-one-key-banner';
import { useLocalization } from '@shared-ui/localization-context';

import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkSpacing } from 'uitk-react-spacing';

import { History, Location } from 'history';

export interface LoyaltyMessagingProps {
  searchResults?: SearchResultsStore;
  multiItem?: MultiItemStore;
}

const handleClick = (history: History, location: Location, l10n: ILocalization) => (isChecked: boolean) => {
  updateSearch({ history, location, newParams: { useRewards: String(isChecked) }, replace: true });

  if (isChecked) {
    setTimeout(() => liveAnnounce(l10n.formatText('common.pointsRemoved'), Level.POLITE), 500);
  } else {
    setTimeout(() => liveAnnounce(l10n.formatText('common.pointsApplied'), Level.POLITE), 500);
  }
};

export const OneKeyBannerToggle: React.FC<LoyaltyMessagingProps> = inject(
  'searchResults',
  'multiItem'
)(
  React.memo(({ searchResults, multiItem }: LoyaltyMessagingProps) => {
    const history = useHistory();
    const location = history.location;
    const l10n = useLocalization();
    const searchCriteria = searchResults?.searchCriteria;

    if (!searchCriteria) return null;

    const getLineOfBusinessDomain = () =>
      multiItem?.isPackageShoppingPath() ? LineOfBusinessDomain.PACKAGES : LineOfBusinessDomain.LODGING;

    const OneKeyBannerInputs = {
      useLoyaltyCurrency: Boolean(searchCriteria && searchCriteria.useRewards === 'true'),
      pageLocation: PageLocation.SEARCH_RESULTS,
      lineOfBusiness: getLineOfBusinessDomain(),
    };

    return (
      <UitkSpacing padding={{ blockstart: 'two' }}>
        <div data-stid="onekeybanner-toggle">
          <OneKeyBanner inputs={OneKeyBannerInputs} switchHandler={handleClick(history, location, l10n)} showBorder={false} skipSsr />
        </div>
      </UitkSpacing>
    );
  })
);

OneKeyBannerToggle.displayName = 'OneKeyBannerToggle';
